import { boolean, object, string } from "../../../types/_types";

export const Peer = object({
	connected: boolean(),
	id: string(5),
});
